import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ScheduleScreen(
    token: String?,
    leagueId: String,
    leagueName: String,
    seasonId: String,
    onMatchClick: (match: MatchDto, homeName: String, awayName: String) -> Unit,
) {
    var matches by remember { mutableStateOf<List<MatchDto>>(emptyList()) }
    var teams by remember { mutableStateOf<Map<String, String>>(emptyMap()) }
    var loading by remember { mutableStateOf(true) }
    var error by remember { mutableStateOf<String?>(null) }

    LaunchedEffect(leagueId) {
        loading = true
        try {
            val teamRows = Api.fetchAllTeamsForSeason(token, seasonId)
            teams = teamRows.associate { it.teamId to (it.teamNameOverride ?: it.team?.name ?: it.teamId) }
            matches = Api.fetchMatches(token, leagueId)
            error = null
        } catch (e: Throwable) {
            error = "Načtení rozpisu selhalo: ${e.apiMessage()}"
        }
        loading = false
    }

    Div(attrs = { classes("card") }) {
        H2 { Text("Rozpis — $leagueName") }
        if (loading) Text("Načítám…")
        error?.let { Div { Text("Chyba: $it") } }

        if (!loading && matches.isEmpty()) {
            Div { Text("Rozpis zatím není vygenerovaný (viz obrazovka Týmy).") }
        }

        // Nadstavba (spec 12): O titul and O udržení share the same round -- one section, not two.
        val groups = matches
            .groupBy { canonicalPlayoffPhase(it.phase) to it.roundNumber }
            .entries
            .sortedWith(compareBy({ phaseOrder(it.key.first) }, { it.key.second }))

        groups.forEach { (key, roundMatches) ->
            val (phase, round) = key
            H3 { Text(roundSlotLabel(phase, round)) }
            Table(attrs = { classes("schedule-table") }) {
                Tr {
                    Th { Text("Domácí") }
                    Th { Text("Hosté") }
                    Th { Text("Výsledek") }
                }
                roundMatches.forEach { m ->
                    val homeName = teams[m.homeTeamId] ?: m.homeTeamId
                    val awayName = teams[m.awayTeamId] ?: m.awayTeamId
                    Tr(attrs = { onClick { onMatchClick(m, homeName, awayName) } }) {
                        Td { Text(homeName) }
                        Td { Text(awayName) }
                        Td { Text(if (m.status == "completed") "${m.homeDuelPoints ?: 0}:${m.awayDuelPoints ?: 0}" else "neodehráno") }
                    }
                }
            }
        }
    }
}
